import type { NuxtAppOptions, Plugin } from '@nuxt/types';

export let myApp: NuxtAppOptions | undefined;

const globalAppContextPlugin: Plugin = ({ app }) => {
  myApp = app;
};

export default globalAppContextPlugin;
